import { render } from "./tpl-banner.vue?vue&type=template&id=783dc445&scoped=true"
import script from "./tpl-banner.vue?vue&type=script&lang=js"
export * from "./tpl-banner.vue?vue&type=script&lang=js"

import "./tpl-banner.vue?vue&type=style&index=0&id=783dc445&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783dc445"],['__file',"src/views/dragger/template/tpl-banner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "783dc445"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('783dc445', __exports__)) {
    console.log('reload')
    api.reload('783dc445', __exports__)
  }
  
  module.hot.accept("./tpl-banner.vue?vue&type=template&id=783dc445&scoped=true", () => {
    console.log('re-render')
    api.rerender('783dc445', render)
  })

}


export default __exports__